// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".toast{bottom:25px;left:auto;margin:auto;position:fixed;right:32px;top:auto;width:300px;z-index:10001}", ""]);
// Exports
module.exports = exports;
